import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BaseWidgetContainer } from 'components/page/BaseLandingPage';
import * as ReactTabs from 'react-tabs';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

// Move WidgetContainer definition here
export const WidgetContainer = styled(BaseWidgetContainer)`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

// Define Tabs wrapper
export const Tabs = styled(ReactTabs.Tabs)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

// Container for TabList and the top-level Workbench Link
export const TabsHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: 1rem;
`;

// Define TabList wrapper
export const TabList = styled(ReactTabs.TabList)`
    display: flex;
    gap: 1.6rem;
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 0.1rem solid ${tokens.border.default};
`;

// Define Tab wrapper
export const Tab = styled(ReactTabs.Tab)`
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
    color: ${tokens.text.primary};
    padding: 0 0 1.6rem 0;
    cursor: pointer;
    border-bottom: 0.2rem solid transparent;
    background-color: transparent;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    /* Active state styles */
    &[aria-selected='true'] {
        border-bottom: 0.2rem solid ${tokens.primary.default};
        color: ${tokens.primary.default};
    }
    /* Keep Focus state on the Tab */
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.2rem ${tokens.primary.default};
    }
    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 0.2rem ${tokens.primary.default};
    }
    @media (max-width: 1470px) {
        gap: 0.3rem;
    }
`;

// Define TabPanel wrapper
export const TabPanel = styled(ReactTabs.TabPanel)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    height: 100%;
    &:not(.react-tabs__tab-panel--selected) {
        display: none;
    }
    > * {
        height: 100%;
        overflow: hidden;
    }
`;

export const HeaderRightContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 0 1.6rem 0;
`;

export const StyledLink = styled.a`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    color: ${tokens.text.link};
    font-size: 1.4rem;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
        text-decoration: underline;
    }
`;

export const ExternalLinkIcon = styled(FontAwesomeIcon)`
    font-size: 1.2rem;
    margin-left: 0.4rem;
`;
